/**
 * Directive Vue v-select-on-focus : sélectionne automatiquement le contenu d'un input au focus.
 */
export default {
	bind(el) {
		const handler = (e) => {
			const input = e.target.tagName === 'INPUT' ? e.target : el.querySelector('input')
			if (input) {
				input.select()
			}
		}
		el.__selectOnFocus = handler
		el.addEventListener('focus', handler, true)
	},
	unbind(el) {
		if (el.__selectOnFocus) {
			el.removeEventListener('focus', el.__selectOnFocus, true)
			delete el.__selectOnFocus
		}
	}
}
